const QUERY_ACCESS_PERMISSION = {
  filter: [{ name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_AVATAR = {
  filter: [{ name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_USER = {
  filter: [
    { name: "code", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_OPERATOR = {
  filter: [{ name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_AGENT = {
  filter: [{ name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_AGENT_BANK = {
  filter: [{ name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_USER_BANK = {
  filter: [{ name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};


const QUERY_USER_TRANSACTION = {
  filter: [
    {name: "user_id", key: "ILike", type: "string" },
    { name: "type", type: "string", key: "ILike" },
    { name: "start_date", type: "string", key: "ILike" },
    { name: "end_date", type: "string", key: "ILike" },
  ],
  order: ["created_at"],
}

const QUERY_USER_TRANSACTION_ALL = {
  filter: [
    { name: "user_code", type: "string", key: "ILike" },
    { name: "type", type: "string", key: "ILike" },
    { name: "start_date", type: "string", key: "ILike" },
    { name: "end_date", type: "string", key: "ILike" },
    {name : "is_finish", type : "string", key:"ILike"}
  ],
  order: ["created_at"],
};

const QUERY_AGENT_TRANSACTION_ALL = {
  filter: [
    { name: "code", type: "string", key: "ILike" },
    { name: "type", type: "string", key: "ILike" },
    { name: "start_date", type: "string", key: "ILike" },
    { name: "end_date", type: "string", key: "ILike" },
  ],
  order: ["created_at"],
};

const QUERY_SOCIAL = {
  filter: [{name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_AGENT_RECEIPT = {
  filter: [{name: "name", key: "ILike", type: "string" }],
  order: ["created_at"],
};

const QUERY_GAME_LOG = {
  filter: [
    {name: "provider", key: "ILike", type: "string" },
    {name: "win_type", key : "ILike", type : "string"},
    {name: "start_date", key : "ILike", type : "string"},
    {name: "end_date", key : "ILike", type : "string"},

  ],
  order: ["created_at"],
}

export {
  QUERY_ACCESS_PERMISSION,
  QUERY_AVATAR,
  QUERY_USER,
  QUERY_OPERATOR,
  QUERY_AGENT,
  QUERY_AGENT_BANK,
  QUERY_USER_BANK,
  QUERY_USER_TRANSACTION,
  QUERY_USER_TRANSACTION_ALL,
  QUERY_SOCIAL,
  QUERY_AGENT_RECEIPT,
  QUERY_GAME_LOG,
  QUERY_AGENT_TRANSACTION_ALL
};
